import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.css'],
})
export class CheckboxInputComponent {
  @Input() test: FormControl<boolean> = new FormControl();
  isCheck = false;
  ngOnInit() {
    this.test?.valueChanges.subscribe((v) => {
      this.isCheck = v;
    });
  }

  onClicK() {
    this.test?.setValue(!this.isCheck);
  }
}
